const Rfqs = () => import("Modules/supply_chain/rfqs/views/Rfqs");
const RfqsForm = () => import("Modules/supply_chain/rfqs/views/RfqsForm");

export default {
    children: [
        {
            path: "purchasing/rfqs",
            name: "rfqs",
            component: Rfqs,
            meta: {
                requiresAuth: true,
                title: "lang.fe_menu_rfq_requests",
                restrict_by_login_type: ["employee", "customer", "vendor"],
                restrict_by_permission: ["rfqs.read"],
            },
        },
        {
            path: "purchasing/rfq/:id?",
            name: "rfq",
            component: RfqsForm,
            meta: {
                requiresAuth: true,
                title: "lang.rfqs",
                restrict_by_login_type: ["employee", "customer", "vendor"],
                restrict_by_permission: ["rfqs.read"],
            },
        },
    ],
};
